export const defaultAttachmentSizeStyles = {
  display: "none"
};